import styled from 'styled-components';

import NavLink from '../../global/NavLink';
import CardContainer from '../../global/CardContainer';
import H1 from '../../global/typography/H1';
import P from '../../global/typography/P';

export const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  > a {
    min-width: 50%;
  }
`;

export const CatLink = styled(P)`
  display: inline;
  color: ${p => p.theme.color.primary};
  font-weight: 500;

  &:hover {
    color: ${p => p.theme.color.secondary};
    text-decoration: underline;
  }

  @media (max-width: ${p => p.theme.deviceWidth.tablet}) {
    display: none;
  }

  &:after {
    padding-left: 10px;
    font-weight: 500;
    content: '>';
    display: inline-block;
  }
`;

export const Mobile = styled.div`
  @media (max-width: ${p => p.theme.deviceWidth.largePhone}) {
    display: flex;
    flex-direction: column;
    width: calc(50% -26px);
    margin-left: 26px;
  }
`;

export const Wrapper = styled(CardContainer)`
  background-color: transparent;
  box-shadow: none;
`;

export const Name = styled(H1).attrs({ as: 'h3' })`
  margin: 16px 0 10px;
  font-size: 20px;

  @media (max-width: ${p => p.theme.deviceWidth.largePhone}) {
    margin: 16px 0 14px;
  }
`;

export const Products = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -16px;
  width: calc(100% + 32px);

  @media (max-width: ${p => p.theme.deviceWidth.largePhone}) {
    margin: 32px 0 0 0;
    width: 100%;
  }
`;

export const Product = styled.div`
  flex-direction: column;
  display: flex;
  width: calc(100% / 4 - 32px);
  margin: 16px 16px 74px;

  @media (max-width: 1200px) {
    margin: 16px 16px 16px;
  }

  @media (max-width: ${p => p.theme.deviceWidth.largePhone}) {
    flex-direction: row;
    width: 100%;
    border-bottom: 1px solid ${props => props.theme.color.borderPrimary};
    margin: 16px 16px 24px;
    padding-bottom: 24px;
    word-break: break-word;
  }
`;

export const Link = styled(NavLink)`
  height: 264px;
  background-image: url('${p => p.image}');
  background-size: 90%;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  @media (max-width: ${p => p.theme.deviceWidth.tablet}) {
    height: 180px;
  }

  @media (max-width: ${p => p.theme.deviceWidth.largePhone}) {
    height: 154px;
    min-width: 45%;
  }
`;

export const MobileCatLink = styled(CatLink)`
  display: none;
  word-break: break-word;

  @media (max-width: ${p => p.theme.deviceWidth.tablet}) {
    display: flex;
  }
`;
